import React from 'react';
import Panel from 'muicss/lib/react/panel';
import Button from 'muicss/lib/react/button';
import Input from 'muicss/lib/react/input';
import Option from 'muicss/lib/react/option';
import Select from 'muicss/lib/react/select';

class SendingTestSetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onChangeValue(name, ev) {
    let state = {};
    state[name] = ev.target.value;
    this.setState(state);
  }

  onSubmit() {
    this.props.onStartTest(this.state);
  }

  testInfo(type) {
    return <p className="mui--text-body2">
      {
        type == "ok" ?
        "OK scenario will accept every valid auth request and transaction and will return customer info." :
        type == "pending-ok" ?
        <span>Pending OK scenario will send <code>pending</code> response and then will accept every valid auth request and will return customer info.</span> :
        type == "deny" ?
        "Deny scenario will deny every auth request and deny sharing customer info." :
        type == "pending-deny" ?
        <span>Pending Deny scenario will send <code>pending</code> response and then will deny every auth request and deny sharing customer info.</span>
        :
        null
      }
      </p>
  }

  render() {
    return <div>
      <div className={this.props.id ? 'hide' : ''}>
        <Select
          readOnly={this.props.initializing}
          onChange={this.onChangeValue.bind(this, "scenario")}
          defaultValue={this.state.scenario}>
          <Option value="" label="Select test..." />
          <Option value="ok" label="Sending: OK scenario" />
          <Option value="pending-ok" label="Sending: Pending OK scenario" />
          <Option value="deny" label="Sending: Deny scenario" />
          <Option value="pending-deny" label="Sending: Pending Deny scenario" />
        </Select>
        {this.testInfo(this.state.scenario)}
        <p><small>
          All tests are performed in the test network.
          You must follow <a href="https://www.stellar.org/developers/guides/compliance-protocol.html" target="_blank">Compliance protocol</a> in order to pass tests.
          Using <a href="https://github.com/stellar/bridge-server" target="_blank">Bridge</a> server can be very helpful.
        </small></p>
        <Button
          color="primary"
          disabled={this.props.initializing || !this.state.scenario}
          onClick={this.onSubmit.bind(this)}>Start test</Button>
      </div>
      <div className={!this.props.id ? 'hide' : ''}>
        <p>Selected test:</p>
        {this.testInfo(this.state.scenario)}
        <div>
          <p>Your recipient address:</p>
          <div className="mui--bg-primary-light mui--text-center">
            <code>{this.props.id}*{process.env.DOMAIN}</code>
          </div>
        </div>
        <button
          className="mui-btn mui-btn--flat mui-btn--danger"
          onClick={this.props.onCancelTest}>Cancel test</button>
      </div>
    </div>
  }
}

SendingTestSetup.propTypes = {
  onStartTest: React.PropTypes.func,
  onCancelTest: React.PropTypes.func,
};

export default SendingTestSetup;



// WEBPACK FOOTER //
// ./src/components/SendingTestSetup.js